import { render } from "./BetaTag.vue?vue&type=template&id=f2247162&scoped=true"
const script = {}

import "./BetaTag.vue?vue&type=style&index=0&id=f2247162&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2247162"]])

export default __exports__